module.exports = __webpack_public_path__ + "img/228164237768720_image.jpg";